<template>
  <v-image :config="{ ...configImage }" ref="imgRef" />
</template>

<script>
import Konva from 'konva'
import { get, min } from 'lodash'
import { mapGetters, mapMutations } from 'vuex'
import { getImageURL } from '@/helper/helper'

export default {
  name: 'image-layer',
  props: {
    layer: {
      type: Object,
      required: true
    },
    mockupID: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      file: null,
      image: null
    }
  },

  mounted() {
    this.file = this.layer.file
  },

  watch: {
    file(file) {
      const { layer, setMockupLoadings, mockupID } = this
      setMockupLoadings({
        mockupID: mockupID,
        key: layer.id,
        loading: true
      })
      if (file && file.key) {
        const img = new window.Image()
        img.onload = () => {
          this.image = img
          this.$nextTick(() => {
            if (this.$refs.imgRef) {
              const node = this.$refs.imgRef.getStage()
              node.cache()
              node.getLayer().batchDraw()
            }
          })
          setMockupLoadings({
            mockupID: mockupID,
            key: layer.id,
            loading: false
          })
        }
        //var preset = 'auto'
        img.crossOrigin = 'Anonymous'
        img.src = getImageURL(file.key, min([layer.width, 1000]), 'px', true) //`${this.$options.CDN_URL}/${preset}/${file.key}`
      }
    }
  },

  computed: {
    ...mapGetters(['mockupLoadings', 'product']),
    configImage() {
      var filters = []
      if (Array.isArray(this.layer._filters)) {
        filters = this.layer._filters.map(filter => get(Konva.Filters, filter))
      }
      return {
        ...this.layer,
        image: this.image,
        filters
      }
    }
  },

  methods: {
    ...mapMutations(['setMockupLoadings'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Mockup/Image.vue